
<template>
  <div>
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <h4 class="modal-title"> Thông Tin Thẻ </h4>
      </div>
      <div class="modal-body">
        <!-- full_name -->
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>{{$t(`customer.card.card_number`)}}</label>
              <input type="text" class="form-control" :placeholder="$t('customer.card.card_number')" v-model="card.card_number">
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-default pull-left"
          data-dismiss="modal"
        >{{$t('common.cancel')}}</button>
        <button
          type="button"
          class="btn btn-primary"
          v-if="!!id"
          @click="onSave"
        >{{$t('common.save')}}</button>
      </div>
    </div>
    <!-- /.modal-content -->
  </div>
</template>

<script>
import {
    mapGetters,
    mapActions
} from "vuex";
import CardStatusEnum from "@/enum/cardStatusEnum";
// import utils from '@/lib/utils'

export default {
  name: "ResidentCardInput",
  props: {
    id: {
      type: Number,
      default: () => { return 0 }
    },
  },
  data() {
    return {
      card: {
        user: null,
        resident_relative: null,
        card_number: null,
        date_registered: null,
        date_sent: null,
        card_accquired_from: null,
        card_status: CardStatusEnum.UNREGISTERED
      }
    }
  },
  watch: {
    id: function() {
      if (this.id !== 0) {
        this.GET_CARD_DETAIL({id:this.id}).then(
          function(res) {
            let card = res
            this.card.user = card.user
            this.card.resident_relative = card.resident_relative
            this.card.card_number = card.card_number
            this.card.date_registered = card.date_registered
            this.card.date_sent = card.date_sent
            this.card.card_accquired_from = card.card_accquired_from
            this.card.card_status = card.card_status
          }.bind(this)
        )
      } else {
        this.reset()
      }
    }
  },
  computed: {
    ...mapGetters([
    ]),
  },
  methods: {
    ...mapActions([
      "GET_CARD_DETAIL"
    ]),
    reset: function() {
      this.card.user = null
      this.card.resident_relative = null
      this.card.card_number = null
      this.card.date_registered = null
      this.card.date_sent = null
      this.card.card_accquired_from = null
      this.card.card_status = CardStatusEnum.UNREGISTERED
    },
    onSave: function() {
      const id = this.id
      const saveCard = {
        user: this.card.user,
        resident_relative: this.card.resident_relative,
        card_number: this.card.card_number,
        date_registered: this.card.date_registered,
        date_sent: this.card.date_sent,
        card_accquired_from: this.card.card_accquired_from,
        card_status: CardStatusEnum.COMPLETED
      }
      this.$emit("card-save", id, saveCard)
    }
  },
  mounted() {
  },
  components: {
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/Customer/ResidentCardInput.vue